<template>
  <div>방 추가</div>
</template>

<script setup></script>
